import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { IconButton, Button } from '@mui/material'

import { FormError } from '../../types/common.types'
import Loader from '../../components/common/loader'
import CloseModalIcon from '../../assets/icons/close-modal-icon.svg'
import { baseButtonWhiteBg, baseButtonBlueBg, baseButtonWarning, baseButtonSuccess } from '../../theme/custom-styles'

const Dialog = ({
  errors,
  children,
  minWidth,
  maxHeight,
  className,
  dialogTitle,
  dialogIsLoading,
  hideCloseOption,
  closeButtonText,
  actionButtonText,
  hideActionsButtons,
  handleDialogAction,
  closeOptionWarning,
  actionButtonDisabled,
  handleDialogOpenState,
  handleCloseOptionAction,
  actionButtonWarningStyle,
  actionButtonSuccessStyle
}: {
  className?: string
  minWidth?: string
  maxHeight?: string
  errors?: FormError
  children: ReactNode
  dialogTitle: string
  closeButtonText?: string
  actionButtonText?: string
  dialogIsLoading?: boolean
  hideCloseOption?: boolean
  hideActionsButtons?: boolean | string
  closeOptionWarning?: boolean
  actionButtonDisabled?: boolean
  handleDialogAction?: () => void
  actionButtonWarningStyle?: boolean
  actionButtonSuccessStyle?: boolean
  handleCloseOptionAction?: () => void
  handleDialogOpenState?: (openState: boolean) => void
}) => {
  const { t } = useTranslation(['common'])

  return (
    <div className="dialog-ovelay">
      <div
        style={minWidth && maxHeight ? { minWidth: `${minWidth}`, maxHeight: `${maxHeight}` } : minWidth && !maxHeight ? { minWidth: `${minWidth}` } : !minWidth && maxHeight ? { maxHeight: `${maxHeight}` } : {}}
        className={className ? `${className} dialog-container dialog-container-min-height` : maxHeight ? 'dialog-container dialog-container-min-height' : 'dialog-container'}
      >
        {dialogIsLoading && <Loader sx={{ right: 0, borderRadius: '20px' }} />}
        <div className="dialog-title-container">
          <div className="dialog-title">{dialogTitle}</div>
          {!hideCloseOption && (
            <IconButton
              edge="end"
              aria-label="toggle password visibility"
              sx={{ color: '#525252' }}
              onClick={() => {
                handleDialogOpenState?.(false)
              }}
            >
              <img
                src={CloseModalIcon}
                alt="close-modal-icon"
              />
            </IconButton>
          )}
        </div>
        <div className="dialog-content-container">{children}</div>
        {errors?.generalError && (
          <div
            style={{ marginTop: '20px' }}
            className="error-message"
          >
            {errors?.generalError}
          </div>
        )}
        {!hideActionsButtons && (
          <div className="dialog-actions-container">
            {!hideCloseOption && (
              <Button
                variant="contained"
                sx={closeOptionWarning ? baseButtonWarning : baseButtonBlueBg}
                onClick={() => {
                  if (handleDialogOpenState && !handleCloseOptionAction) handleDialogOpenState(false)

                  if (handleCloseOptionAction) handleCloseOptionAction()
                }}
              >
                {closeButtonText ?? t('buttonsTexts.cancel')}
              </Button>
            )}
            <Button
              variant="contained"
              disabled={actionButtonDisabled ?? false}
              sx={actionButtonWarningStyle ? baseButtonWarning : actionButtonSuccessStyle ? baseButtonSuccess : baseButtonWhiteBg}
              onClick={() => handleDialogAction?.()}
            >
              {actionButtonText || ''}
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}

export default Dialog
